export enum FileOwner {
    Account = 'account',
    Group = 'group',
    User = 'user'
}

export enum FileArea {
    LiveHelp = 'live-help',
    Profile = 'profile',
    ClientSession = 'client-session',
    AccountLogo = 'account-logo',
    SessionVirtualBackground = 'session-virtual-background',
    ClientConnectLogo = 'client-connect-logo'
}

export type FilesManagerProps = {
    ownerType: FileOwner;
    area: FileArea;
    ownerId?: string;
}

export type FileInfo = {
    path: string;
    name: string;
}
